module.exports = __webpack_public_path__ + "static/media/Yearbook Solid.a35f4743.ttf";